var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 82.375L24 34.375C24 27.7575 29.3825 22.375 36 22.375L52 22.375L52 28.375L36 28.375C32.6925 28.375 30 31.0675 30 34.375L30 82.375C30 85.6825 32.6925 88.375 36 88.375L52 88.375L52 94.375L36 94.375C29.3825 94.375 24 88.9925 24 82.375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 55.375L36 61.375L93 61.375L93 55.375L36 55.375Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2725 58.3751C95.2725 61.3626 94.11 64.1701 91.9975 66.2826L70.7825 87.4976L66.54 83.2551L87.755 62.0401C88.735 61.0601 89.2725 59.7601 89.2725 58.3751C89.2725 56.9901 88.7325 55.6901 87.755 54.7101L66.54 33.4951L70.7825 29.2526L91.9975 50.4676C94.11 52.5801 95.2725 55.3876 95.2725 58.3751Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.ebb24c24.svg";
export { ForwardRef as ReactComponent };